
<div class="tonnage-results" >
    <p-table [value]="lmpsTonnageRatings" id="LmsTonnageRatingLmpsTable" responsiveLayout="scroll"  [resizableColumns]="true" [responsive]="true">
        <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let item of lmpsHeadings; " style="vertical-align:bottom" pResizableColumn>
                <div *ngFor="let item1 of item.split('|');">{{item1}} </div></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tonnage>
            <tr>
                <td>{{ tonnage.routeSeq }}</td>
                <td>{{ tonnage.departStation }} - {{ tonnage.departMilepost }}</td>
                <td>{{tonnage.departTime}}</td>
                <td>{{ tonnage.arriveStation }} - {{tonnage.arriveMilepost}}</td>
                <td>{{tonnage.arriveTime}}</td>
                <td>{{ tonnage.miles }}</td>
                <td [ngClass]="tonnage.highlight == 'T' ? 'highlight-color' : ''">{{ tonnage.tonCat1 }}</td>
                <td [ngClass]="tonnage.highlight == 'T' ? 'highlight-color' : ''">{{ tonnage.tonCat2 }}</td>
                <td [ngClass]="tonnage.highlight == 'T' ? 'highlight-color' : ''">{{ tonnage.tonCat3 }}</td>
                <td [ngClass]="tonnage.highlight == 'T' ? 'highlight-color' : ''">{{ tonnage.tonCat4 }}</td>
                <td [ngClass]="tonnage.highlight == 'T' ? 'highlight-color' : ''">{{ tonnage.tonCat5 }}</td>
                <td [ngClass]="tonnage.highlight == 'T' ? 'highlight-color' : ''">{{ tonnage.tonCat6 }}</td>
                <td [ngClass]="tonnage.highlight == 'T' ? 'highlight-color' : ''">{{ tonnage.tonCat7 }}</td>
                <td [ngClass]="tonnage.highlight == 'T' ? 'highlight-color' : ''">{{ tonnage.tonCat8 }}</td>
                <td [ngClass]="tonnage.highlight == 'T' ? 'highlight-color' : ''">{{ tonnage.tonCat9 }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td>No Data Found</td>
          </tr>
        </ng-template>
    </p-table>
</div>
